"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOpenMissingDocsRequestKey = exports.formatProvidedMissingInfos = exports.isExpectedMissingDocumentsObject = exports.parseMissingDocumentsString = exports.removeDefaultFormattedMissingDocuments = exports.formatMissingDocumentsAfterPurchase = exports.formatProvidedDocuments = exports.sortPersonKeys = exports.splitPersonKey = exports.getPersonIndex = exports.getPersonKey = exports.hasTaxReport = void 0;
const tslib_1 = require("tslib");
const constants_1 = require("./constants");
tslib_1.__exportStar(require("./constants"), exports);
tslib_1.__exportStar(require("./person"), exports);
function hasTaxReport(person) {
    return person.personType === constants_1.PERSON_TYPES.self || person.hasTaxReport;
}
exports.hasTaxReport = hasTaxReport;
function getPersonKey(personType, personIndex = 0) {
    return `${personType}${personIndex}`;
}
exports.getPersonKey = getPersonKey;
function getPersonIndex(personKey) {
    const match = personKey?.match(/\d+$/) || [];
    return match[0];
}
exports.getPersonIndex = getPersonIndex;
function splitPersonKey(personKey) {
    const [, personType, personIndex] = personKey.match(/^([^\d]+)(\d+)$/) || [];
    if (!personType || !personIndex)
        throw new Error(`Invalid personKey format: ${personKey}`);
    const validPersonType = Object.values(constants_1.PERSON_TYPES).find(type => type === personType);
    if (!validPersonType)
        throw new Error(`Invalid person type in provided personKey: ${personKey}`);
    const personIndexNum = parseInt(personIndex);
    if (personIndexNum < 0)
        throw new Error(`Person index must be > 0, received "${personIndexNum}`);
    return { personType: validPersonType, personIndex: personIndexNum };
}
exports.splitPersonKey = splitPersonKey;
function sortPersonKeys(personKeys) {
    const getSortIndex = (personKey) => {
        const { personType, personIndex } = splitPersonKey(personKey);
        return constants_1.PERSON_TYPES_ORDER.indexOf(personType) + personIndex;
    };
    return personKeys.sort((a, b) => getSortIndex(a) - getSortIndex(b));
}
exports.sortPersonKeys = sortPersonKeys;
function formatProvidedDocuments(providedDocuments) {
    let jsonProvidedDocuments = providedDocuments && typeof providedDocuments === 'object' ? providedDocuments : {};
    if (typeof providedDocuments === 'string') {
        try {
            jsonProvidedDocuments = JSON.parse(providedDocuments);
        }
        catch (err) { }
    }
    const returned = { providedBeforePayment: {}, providedAfterPayment: undefined };
    for (const documentKey in jsonProvidedDocuments) {
        const { filename, sorting, wasMissing } = jsonProvidedDocuments[documentKey];
        const prop = !wasMissing ? 'providedBeforePayment' : 'providedAfterPayment';
        returned[prop] = returned[prop] || {};
        returned[prop][documentKey] = { filename, sorting, wasMissing };
    }
    return returned;
}
exports.formatProvidedDocuments = formatProvidedDocuments;
function formatMissingDocumentsAfterPurchase(missingDocuments) {
    const getDefault = () => ({ '0': { docs: [], infos: [] } });
    let parsed = missingDocuments && typeof missingDocuments === 'object' ? missingDocuments : getDefault();
    if (typeof missingDocuments === 'string') {
        try {
            parsed = JSON.parse(missingDocuments);
        }
        catch (err) { }
    }
    if (!parsed || typeof parsed !== 'object')
        return getDefault();
    let sanitized;
    if ('docs' in parsed && Array.isArray(parsed.docs)) {
        sanitized = { '0': parsed };
    }
    else {
        sanitized = parsed;
    }
    let filtered = null;
    for (const timestamp in sanitized) {
        filtered = filtered || {};
        if (isExpectedMissingDocumentsObject(sanitized[timestamp])) {
            filtered[timestamp] = sanitized[timestamp];
        }
    }
    return filtered || getDefault();
}
exports.formatMissingDocumentsAfterPurchase = formatMissingDocumentsAfterPurchase;
function removeDefaultFormattedMissingDocuments(obj) {
    if ('0' in obj &&
        obj['0'] &&
        typeof obj['0'] === 'object' &&
        'docs' in obj['0'] &&
        Array.isArray(obj['0'].docs) &&
        !obj['0'].docs.length &&
        'infos' in obj['0'] &&
        Array.isArray(obj['0'].infos) &&
        !obj['0'].infos.length) {
        delete obj['0'];
    }
}
exports.removeDefaultFormattedMissingDocuments = removeDefaultFormattedMissingDocuments;
function parseMissingDocumentsString(str) {
    let parsed;
    try {
        parsed = JSON.parse(str);
    }
    catch (err) { }
    return isExpectedMissingDocumentsObject(parsed) ? parsed : undefined;
}
exports.parseMissingDocumentsString = parseMissingDocumentsString;
function isExpectedMissingDocumentsObject(obj) {
    return ['docs', 'infos'].every(key => key in obj && Array.isArray(obj[key]) && obj[key].every(item => Array.isArray(item)));
}
exports.isExpectedMissingDocumentsObject = isExpectedMissingDocumentsObject;
/**
 * Used for both single info object and multiple infos object
 *
 * @example
 * formatProvidedMissingInfos('{"info-self0-1":"foo"}') // single info
 * formatProvidedMissingInfos('{"1709233128495":{"info-self0-1":"foo"}}') // multiple infos
 */
function formatProvidedMissingInfos(infos) {
    let parsed = infos;
    if (typeof infos === 'string') {
        try {
            parsed = JSON.parse(infos);
        }
        catch (err) { }
    }
    return parsed && typeof parsed === 'object' ? parsed : {};
}
exports.formatProvidedMissingInfos = formatProvidedMissingInfos;
function getOpenMissingDocsRequestKey(missingInfosDocsSubmittedAt, missingDocuments) {
    const submittedAt = (missingInfosDocsSubmittedAt ? Number(missingInfosDocsSubmittedAt) : 0) || 0;
    try {
        const requestTimestamps = Object.keys(missingDocuments)
            .map(t => Number(t))
            .sort();
        const timestamp = requestTimestamps.find(t => t >= submittedAt);
        return typeof timestamp !== 'undefined' &&
            (missingDocuments[timestamp].docs.length || missingDocuments[timestamp].infos.length)
            ? timestamp
            : undefined;
    }
    catch (err) {
        return undefined;
    }
}
exports.getOpenMissingDocsRequestKey = getOpenMissingDocsRequestKey;
//# sourceMappingURL=index.js.map